<template>
<div class="chapter">
<div class="inner_page">
<p class="chap-img"><img alt="image" src="images/img39.jpg"/></p>
<p class="chap"><a id="ch18"></a>ANNE HUTCHINSON, 1640</p>
<p class="noindent"><span class="big">I</span>n the 1630s, Anne Hutchinson and her family immigrated to New England to escape religious persecution. An intelligent and independent thinker, Anne began to hold a weekly discussion group in her home, where she criticized the colony’s religious and political leaders for narrow views on morality and religion.</p>
<p class="indent">The colony saw Hutchinson as a threat and passed a law banning women from organizing, leading, or even attending such meetings without their husbands. When Anne refused to stop, Governor John Winthrop put her on trial. She sealed her fate with an emotional outburst, claiming God spoke to her directly and some ministers in Boston did not teach the truth. She was found guilty and then later, in a church trial, was excommunicated and banished.</p>
<p class="indent">The Hutchinson group settled in what became Rhode Island. Then, fearing annexation by Massachusetts, the family fled to present-day Long Island where in 1643 they were killed in an American Indian uprising. <span class="color">(07-024, 07-025)</span></p>
<p class="image"><img alt="image" src="images/img40.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter018.vue?650fa976